// extracted by mini-css-extract-plugin
export default {"Reset":"CareerAdd_Reset__EvYXX","details":"CareerAdd_details__a+Rp5","section":"CareerAdd_section__aheuo","Button":"CareerAdd_Button__DW6CK","Bottom":"CareerAdd_Bottom__HdKUJ"};